import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import '../../v2-theme.css';
import './AuthPages.css';

/**
 * Worker Login Page
 * Matches worker-login.html exactly
 */
const WorkerLogin = () => {
  const navigate = useNavigate();
  const { signIn } = useAuth();

  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const { user } = await signIn(formData.email, formData.password);

      // Verify user type is worker
      if (user.user_type !== 'worker') {
        setError('This account is not a worker account. Please use the restaurant login.');
        setLoading(false);
        return;
      }

      // Redirect to worker dashboard
      navigate('/dashboard/worker');
    } catch (err) {
      console.error('Login error:', err);
      setError(err.message || 'Invalid email or password');
      setLoading(false);
    }
  };

  const handleForgotPassword = () => {
    navigate('/forgot-password');
  };

  return (
    <div className="auth-page">
      <div className="auth-container">
        <header className="auth-header">
          <div className="auth-logo-title">
            <img src="/hotf-web-icon.png" alt="Hands On The Fly" className="auth-logo" />
            <h1>Hands On The Fly</h1>
          </div>
        </header>

        <Link to="/" className="auth-back-link">← Back to Home</Link>

        <h2 className="auth-heading">Worker Login</h2>
        <p className="auth-subtitle">Kitchen Staff</p>

        <form className="auth-form" onSubmit={handleSubmit}>
          {error && (
            <div className="auth-error-message">{error}</div>
          )}

          <div className="auth-form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              disabled={loading}
            />
          </div>

          <div className="auth-form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              disabled={loading}
            />
            <div className="auth-forgot-password">
              <button
                type="button"
                onClick={handleForgotPassword}
                className="auth-forgot-link"
              >
                Forgot Password?
              </button>
            </div>
          </div>

          <button type="submit" className="auth-submit-btn" disabled={loading}>
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>

        <div className="auth-register-link">
          <p>Need an account?</p>
          <button
            className="auth-register-btn"
            onClick={() => navigate('/worker-register')}
          >
            Register
          </button>
        </div>
      </div>
    </div>
  );
};

export default WorkerLogin;
